import * as z from "zod";
//#region src/__generated__/viewer/modelIdCacheController/zod/getModelIdsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getModelIdsPathKeyIdSchema = z.uuid();
const getModelIdsStatus200Schema = z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" });
const getModelIdsResponseSchema = getModelIdsStatus200Schema;
//#endregion
//#region src/__generated__/viewer/modelIdCacheController/zod/viewerModelIdsRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const viewerModelIdsRequestSchema = z.object({ modelIds: z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }) });
//#endregion
//#region src/__generated__/viewer/modelIdCacheController/zod/saveModelIdsAtRedisSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const saveModelIdsAtRedisStatus200Schema = z.uuid();
const saveModelIdsAtRedisResponseSchema = saveModelIdsAtRedisStatus200Schema;
const saveModelIdsAtRedisDataSchema = viewerModelIdsRequestSchema;
//#endregion
export { getModelIdsPathKeyIdSchema as a, viewerModelIdsRequestSchema as i, saveModelIdsAtRedisResponseSchema as n, getModelIdsResponseSchema as o, saveModelIdsAtRedisStatus200Schema as r, getModelIdsStatus200Schema as s, saveModelIdsAtRedisDataSchema as t };

//# sourceMappingURL=saveModelIdsAtRedisSchema.js.map